import React from "react";
import { motion } from "framer-motion";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FaArrowTrendUp } from "react-icons/fa6";
import { FiBookOpen, FiTarget } from "react-icons/fi";
import Card from "../../../components/ui/Card";

const iconMap = [
  <FiBookOpen size={28} />,
  <FaArrowTrendUp size={28} />,
  <FiTarget size={28} />,
];

export default function PostulatePillars() {
  const { t } = useTranslation();
  const items = t("postulate.pillars.items", { returnObjects: true }) as any[];

  return (
    <Box
      component="section"
      sx={{
        py: 10,
        bgcolor: "#f8fafc",
        position: "relative",
        zIndex: 10,
        mt: -5,
        borderRadius: "3rem 3rem 0 0",
         
      }}
    >
      <Container maxWidth="xl">
        {/* Encabezado animado */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          sx={{ textAlign: "center", mb: 8 }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              color: "#0A1128",
              mb: 2,
              fontSize: { xs: "1.875rem", md: "2.25rem" },
              letterSpacing: "-0.025em",
            }}
          >
            {t("postulate.pillars.mainTitle")}
          </Typography>
          <Box
            sx={{
              width: 64,
              height: 4,
              bgcolor: "#68a8de",
              mx: "auto",
              borderRadius: "9999px",
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            flexWrap: { xs: "nowrap", md: "wrap" },
            gap: 4,
          }}
        >
          {Array.isArray(items) &&
            items.map((item, idx) => (
              <Box
                key={idx}
                sx={{
                  width: { xs: "100%", md: "calc(33.333% - 22px)" },
                }}
              >
                <Card icon={iconMap[idx]} item={item} idx={idx} />
              </Box>
            ))}
        </Box>
      </Container>
    </Box>
  );
}
